import { Sort } from '@angular/material/sort';

export var SITE_VERSION = "3.1.2";

export class Constants {

  public static countries: Country[] = [
    { name: "Germany", vo: "Deutschland", fr: "Allemagne", txt: "scaleform.allemagne", tvaRegEx: "^DE[0-9]{9}$" },
    { name: "United Kingdom", vo: "United Kingdom", fr: "Royaume-Uni", txt: "scaleform.angleterre", tvaRegEx: "^GB([0-9]{9}|[0-9]{12}|GD[0-9]{3}|HA[0-9]{3})$" },
    { name: "Spain", vo: "España", fr: "Espagne", txt: "scaleform.espagne", tvaRegEx: "^ES[A-Z0-9][0-9]{7}[A-Z0-9]$" },
    { name: "France", vo: "France", fr: "France", txt: "scaleform.france", tvaRegEx: "^FR[0-9A-Z]{2}[0-9]{9}$" },
    { name: "Belgium", vo: "Belgique", fr: "Belgique", txt: "scaleform.belgique", tvaRegEx: "^BE0[0-9]{9}$" },
    { name: "Italy", vo: "Italia", fr: "Italie", txt: "scaleform.italie", tvaRegEx: "^IT[0-9]{11}$" },
    { name: "Luxembourg", vo: "Luxembourg", fr: "Luxembourg", txt: "scaleform.luxembourg", tvaRegEx: "" },
    { name: "Netherlands", vo: "Nederland", fr: "Pays-Bas", txt: "scaleform.paysbas", tvaRegEx: "^NL[0-9]{9}B[0-9]{2}$" },
    { name: "Poland", vo: "Polska", fr: "Pologne", txt: "scaleform.pologne", tvaRegEx: "^PL[0-9]{10}$" },
    { name: "Portugal", vo: "Portugal", fr: "Portugal", txt: "scaleform.portugal", tvaRegEx: "^PT[0-9]{9}$" },
    { name: "Romania", vo: "România", fr: "Roumanie", txt: "scaleform.roumanie", tvaRegEx: "^RO[0-9]{2,10}$" },
    { name: "Turkey", vo: "Türkiye", fr: "Turquie", txt: "scaleform.turquie", tvaRegEx: "" },
    { name: "Mayotte", vo: "Mayotte", fr: "Mayotte", txt: "scaleform.mayotte", tvaRegEx: "" },
    { name: "Ivory Coast", vo: "Côte d’Ivoire", fr: "Côte d’Ivoire", txt: "scaleform.coteIvoire", tvaRegEx: "" },
    { name: "Cameroon", vo: "Cameroun", fr: "Cameroun", txt: "scaleform.cameroun", tvaRegEx: "" },
    { name: "Austria", vo: "Österreich", fr: "Österreich", txt: "scaleform.autriche", tvaRegEx: "^ATU[0-9]{8}$" }
  ];

  public static sortScale(sort: Sort, status: string, data: any) {

    if (!sort.active || sort.direction === '') {
      return;
    }
    data = data.sort((a: any, b: any) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case "nom":
          return Constants.compare(a.name, b.name, isAsc);
        case "prenom":
          return Constants.compare(a.firstName, b.firstNameame, isAsc);
        case "langue":
          return Constants.compare(a.language, b.language, isAsc);
        case "region":
          return Constants.compare(a.dr, b.dr, isAsc);
        case "Nom_RS":
          return Constants.compare(a.nom_ou_RS, b.nom_ou_RS, isAsc);
        case "Numserie":
          return Constants.compare(a.sN_Balance, b.sN_Balance, isAsc);
        case "Dateinstallation":
          return Constants.compare(a.date_installation, b.date_installation, isAsc);
        case "Fincontrat":
          return Constants.compare(a.fin_de_contrat, b.fin_de_contrat, isAsc);
        case "Bdd Locale":
          return Constants.compare(a.bddlocale, b.bddlocale, isAsc);
        case "Bdd Internet":
          return Constants.compare(a.bddinternet, b.bddinternet, isAsc);
        case "Spectro":
          return Constants.compare(a.spectro, b.spectro, isAsc);
        case 'RS':
          return Constants.compare(a.raison_sociale, b.raison_sociale, isAsc);
        case 'Code Postal':
          return Constants.compare(a.code_Postal, b.code_Postal, isAsc);
        case 'Adresse1':
          return Constants.compare(a.adresse1, b.adresse1, isAsc);
        case 'Adresse2':
          return Constants.compare(a.adresse2, b.adresse2, isAsc);
        case 'Ville':
          return Constants.compare(a.ville, b.ville, isAsc);
        case 'CTC':
          return Constants.compare(a.ctc, b.ctc, isAsc);
        case 'mouvement':
        case 'activationID':
          return Constants.compare(a.activationID, b.activationID, isAsc);
        case 'scaleCode':
          return Constants.compare(parseInt(a.scaleCode), parseInt(b.scaleCode), isAsc);
        case 'activationDate':
          return Constants.compareDate(a.activationDate, b.activationDate, isAsc);
        case 'transDate':
          return Constants.compareDate(a.transDate, b.transDate, isAsc);
        case "invoiceDate":
          return Constants.compareDate(a.invoiceDate, b.invoiceDate, isAsc);
        case 'orderDate':
          return Constants.compareDate(a.transDate, b.transDate, isAsc);
        case 'ctcName':
        case 'ctc':
          a.ctcName = (a.ctcName) ? a.ctcName.toUpperCase() : "";
          b.ctcName = (b.ctcName) ? b.ctcName.toUpperCase() : "";
          return Constants.compare(a.ctcName.toUpperCase(), b.ctcName.toUpperCase(), isAsc);
        case 'userLoginUnisite':
          return Constants.compare(a.userLoginUnisite, b.userLoginUnisite, isAsc);
        case 'companyUnisiteCode':
          return Constants.compare(a.companyUnisiteCode, b.companyUnisiteCode, isAsc);
        case 'payorLoginUnisite':
          return Constants.compare(a.payorLoginUnisite, b.payorLoginUnisite, isAsc);
        case 'companyPayorUnisiteCode':
          return Constants.compare(a.companyPayorUnisiteCode, b.companyPayorUnisiteCode, isAsc);
        case 'activationCode':
          return Constants.compare(a.activationCode, b.activationCode, isAsc);
        case 'orderNumber':
          return Constants.compare(a.orderNumber, b.orderNumber, isAsc);
        case 'nbProducts':
          return Constants.compare(a.nbProducts, b.nbProducts, isAsc);
        case 'amount':
          return Constants.compare(a.amountTotal, b.amountTotal, isAsc);
        case 'sageCode':
          return Constants.compare(parseInt(a.sageCode), parseInt(b.sageCode), isAsc);
        case 'facture':
        case 'invoiceCode':
          return Constants.compare(a.invoiceCode, b.invoiceCode, isAsc);
        case 'rentingDate':
          return Constants.compare(a.rentingDate, b.rentingDate, isAsc);
        case 'treatmentDate':
          return Constants.compareDate(a.treatmentDate, b.treatmentDate, isAsc);
        case 'rentingId':
          return Constants.compare(a.rentingID, b.rentingID, isAsc);
        case 'leader':
          return Constants.compare(a.leader.toUpperCase(), b.leader.toUpperCase(), isAsc);
        case 'bodyshopInterlocutor':
          return Constants.compare(a.bodyshopInterlocutor, b.bodyshopInterlocutor, isAsc);
        case 'ctcPhone':
          return Constants.compare(a.ctcPhone, b.ctcPhone, isAsc);
        case 'ctcMail':
          return Constants.compare(a.ctcMail.toUpperCase(), b.ctcMail.toUpperCase(), isAsc);
        case 'rentingDuration':
          return Constants.compare(a.rentingDuration, b.rentingDuration, isAsc);
        case 'bank':
          return Constants.compare(a.bank, b.bank, isAsc);
        case 'invoiceCode1':
          return Constants.compare(a.invoiceCode1, b.invoiceCode1, isAsc);
        case 'nameFile':
          return Constants.compare(a.breakdownName.toUpperCase(), b.breakdownName.toUpperCase(), isAsc);
        case 'dateFile':
        case 'dateFileEdit':
          return Constants.compareDate(a.fileDate.toLocaleDateString("fr"), b.fileDate.toLocaleDateString("fr"), isAsc);
        case 'sended':
          return Constants.compareDateString(a.dateMailSent, b.dateMailSent, isAsc);
        case 'status':
          return Constants.compare(a.status, b.status, isAsc);
        case 'country':
          return Constants.compare(a.country, b.country, isAsc);
        case 'Pays':
          if(a.pays)
            return Constants.compare(a.pays, b.pays, isAsc);
          else
            return Constants.compare(a.country, b.country, isAsc);
        case 'city':
          return Constants.compare(a.postalCode, b.postalCode, isAsc);
        case 'companySocialReason':
          if (a.companySocialReason)
            return Constants.compare(a.companySocialReason.toUpperCase(), b.companySocialReason.toUpperCase(), isAsc);
          else
            return Constants.compare(a.socialReason.toUpperCase(), b.socialReason.toUpperCase(), isAsc);
        case 'socialReason':
          if (a.adresseFacturation)
            return Constants.compare(a.adresseFacturation.socialReason.toUpperCase(), b.adresseFacturation.socialReason.toUpperCase(), isAsc);
        case 'address':
          return Constants.compare(a.postalCode, b.postalCode, isAsc);
        case 'firstName':
          return Constants.compare(a.firstname?.toUpperCase(), b.firstname?.toUpperCase(), isAsc);
        case 'name':
          return Constants.compare(a.name?.toUpperCase(), b.name?.toUpperCase(), isAsc);
        case 'idcolorUser':
          return Constants.compare(a.idcolorUser, b.idcolorUser, isAsc);
        case 'unisiteCode':
          return Constants.compare(a.unisiteCode, b.unisiteCode, isAsc);
        // planning - Historique
        case 'rdvID':
          return Constants.compare(a.rdv.rdvID, b.rdv.rdvID, isAsc);
        case 'typeIntervention':
          return Constants.compare(a.typeIntervention, b.typeIntervention, isAsc);
        case 'user':
          return Constants.compare(a.user_SocialReason, b.user_SocialReason, isAsc);
        case 'statusRDV':
          return Constants.compare(a.rdv.status, b.rdv.status, isAsc);
        case 'dateRDV':
          return Constants.compare(a.rdv.startDate, b.rdv.startDate, isAsc);
        case 'duration':
          return Constants.compare(a.duration, b.duration, isAsc);
        // planning - Gestion
        case 'rdvID_G':
          return Constants.compare(a.rdvID, b.rdvID, isAsc);
        case 'statusRDV_G':
          return Constants.compare(a.status, b.status, isAsc);
        case 'dateRDV_G':
          return Constants.compare(a.startDate, b.startDate, isAsc);
        case 'hotliner':
          return Constants.compare(a.loginHotliner, b.loginHotliner, isAsc);
        case 'ctc_G':
          return Constants.compare(a.ctc_Name, b.ctc_Name, isAsc);
        case 'ctcPhone_G':
          return Constants.compare(a.ctc_Phone, b.ctc_Phone, isAsc);
          //if (a.name)
          //  return Constants.compare(a.name.toUpperCase(), b.name.toUpperCase(), isAsc);
          //else if (a.region)
          //  return Constants.compare(a.region.toUpperCase(), b.region.toUpperCase(), isAsc);
          //else if (a.country)
          //  return Constants.compare(a.country.toUpperCase(), b.country.toUpperCase(), isAsc);
        // monitoring interne
        case 'errorCode':
          return Constants.compare(a.code, b.code, isAsc);
        case 'errorDate':
          return Constants.compare(a.iderrorlog, b.iderrorlog, isAsc);
        case 'errorDescription':
          return Constants.compare(a.description, b.description, isAsc);
        case 'errorParameters':
          return Constants.compare(a.parameters, b.parameters, isAsc);
        case 'nbSent':
          if (a.stats)
            return Constants.compare(a.stats.nbAccountActivated, b.stats.nbAccountActivated, isAsc);
          else
            return Constants.compare(a.nbAccountActivated, b.nbAccountActivated, isAsc);
        case 'nbCreated':
          if (a.stats)
            return Constants.compare(a.stats.nbAccountCreated, b.stats.nbAccountCreated, isAsc);
          else
            return Constants.compare(a.nbAccountCreated, b.nbAccountCreated, isAsc);
        case 'histo':
          return Constants.compare(a.nbConnection, b.nbConnection, isAsc);
        // historique balance
        case 'scaleHistoryID':
          return Constants.compare(a.scaleHistoryID, b.scaleHistoryID, isAsc);
        case 'orderDate':
          return Constants.compareDate(a.orderDate, b.orderDate, isAsc);
        case 'scaleID':
          return Constants.compare(a.scaleID, b.scaleID, isAsc);
        case 'serialNumber':
          return Constants.compare(a.serialNumber, b.serialNumber, isAsc);
        case 'code':
          return Constants.compare(a.code, b.code, isAsc);
        case 'licenceStartDate':
          return Constants.compareDate(a.licenceStartDate, b.licenceStartDate, isAsc);
        case 'licenceEndDate':
          return Constants.compareDate(a.licenceEndDate, b.licenceEndDate, isAsc);
        case 'statsVisitsPage':
          return Constants.compare(a.statsVisitsPage, b.statsVisitsPage, isAsc);
        case 'statsVisitsNb':
          return Constants.compare(a.statsVisitsNb, b.statsVisitsNb, isAsc);
        default: return 0;
      }
    });
  }

  public static compare(a: number | string, b: number | string, isAsc: boolean) {
    if (a == null) return -1;
    return (a < b ? -1 : 1) * (isAsc ? -1 : 1);
  }

  public static compareDate(a: string, b: string, isAsc: boolean) {
    if (a == null) return -1;
    return (new Date(a).getTime() < new Date(b).getTime() ? -1 : 1) * (isAsc ? -1 : 1);
  }

  public static compareDateString(a: string, b: string, isAsc: boolean) {
    let atmp: string[];
    atmp = a.split("/");
    let btmp: string[];
    btmp = b.split("/");
    if (a == null) return -1;
    return (new Date(atmp[1] + "/" + atmp[0] + "/" + atmp[2]).getTime() < new Date(btmp[1] + "/" + btmp[0] + "/" + btmp[2]).getTime() ? -1 : 1) * (isAsc ? -1 : 1);
  }
}

export class Country {
  name: string;
  vo: string;
  fr: string;
  txt: string;
  tvaRegEx: string;
}
